import React from 'react'
import { Layout, theme } from 'antd'

const Footer = () => {
  const {
    token: { colorBgContainer }
  } = theme.useToken()
  const year = new Date().getFullYear()
  
  return (
    <Layout.Footer
      style={{
        padding: '16px 0',
        width: '100%',
        backgroundColor: colorBgContainer,
        textAlign: 'center'
      }}
    >
        All rights reserved. © {year} Telusio GmbH 
    </Layout.Footer>
  )
}

export default Footer
